import { render, staticRenderFns } from "./GuidesToolbar.vue?vue&type=template&id=5db2477c"
import script from "./GuidesToolbar.vue?vue&type=script&lang=js"
export * from "./GuidesToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports